export default __webpack_public_path__ + "static/media/logo2.995f0d34.svg";